'use strict';

var _ = require('lodash');
var GridToolbarConfigurationUserDefinedRefDataFlightController = function GridToolbarConfigurationUserDefinedRefDataFlightController($scope, $rootScope, urdToolbarService, urdConstants, printService, toolbarGridService) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  var HEP_TYPE = urdConstants.HEP_TYPE.FLIGHT;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  $scope.addURDFlightRow = function () {
    urdToolbarService.addURDRow($scope.jqxGridSettings.source.loadedData, $scope.jqxGridSettings.columns);
    $scope.updateData($scope.jqxGridSettings.source.loadedData);
  };
  $scope.duplicateURDFlightRow = function () {
    urdToolbarService.duplicateURDRow($scope.jqxGridSettings.source.loadedData, $scope.jqxGridSettings.jqxGrid('getselectedrowindex'), $scope.jqxGridSettings.columns);
    $scope.updateData($scope.jqxGridSettings.source.loadedData);
  };
  function flightHepKeyCreator(urdRow) {
    var filter = [];
    filter.push(HEP_TYPE);
    filter.push(urdRow.airline || null);
    filter.push(urdRow.flightEntity || null);
    if (urdRow.flightLeg) {
      filter = filter.concat(urdRow.flightLeg.split('-'));
    }
    filter.push(urdRow.flightNumber || null);
    filter.push(urdRow.cabin || null);
    filter.push(urdRow.season || null);
    filter.push(urdRow.dowGroup || null);
    filter.push(urdRow.referenceMetric ? urdToolbarService.getFlightReferenceMetric(urdRow.referenceMetric) : null);
    return filter.filter(Boolean).join('.');
  }
  var rowsToRemoveFromServer = [];
  $scope.removeURDFlightRow = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndexes = $scope.jqxGridSettings.jqxGrid('getselectedrowindexes');
    for (var i = 0; i < selectedIndexes.length; i++) {
      var row = loadedData[selectedIndexes[i]];
      if (!row.isRowEditable && !row.isNewlyAdded) {
        rowsToRemoveFromServer.push(row);
      }
    }
    toolbarGridService.removeRow($scope);
  };
  $scope.saveChanges = function () {
    if (!_.isEmpty(rowsToRemoveFromServer)) {
      urdToolbarService.removeURDRow(rowsToRemoveFromServer, HEP_TYPE, flightHepKeyCreator).then(function () {
        rowsToRemoveFromServer = [];
        $scope.$emit('grid:dataChanged');
      });
    }
    urdToolbarService.save(HEP_TYPE, $scope.jqxGridSettings.source.loadedData, flightHepKeyCreator).then(function () {
      $scope.$emit('grid:dataChanged');
    });
  };
  $scope.exportedDataTransformer = function (xmlString) {
    return xmlString.replace(/DISABLED/g, 'INACTIVE');
  };
  $scope["import"] = function () {
    $scope.isImportValidationError = false;
    $rootScope.$broadcast('grid:showImportModal', $scope.gridId);
  };
  $scope.printGrid = function () {
    $scope.asyncGridApply('exportdata', 'html').then(function (gridContent) {
      printService.print($scope.gridId, $scope.exportedDataTransformer(gridContent));
    });
  };
};
GridToolbarConfigurationUserDefinedRefDataFlightController.$inject = ['$scope', '$rootScope', 'ConfigurationUserDefinedRefDataGridToolbarFunctionsService', 'UrdConstants', 'PrintService', 'ToolbarGridService'];
module.exports = GridToolbarConfigurationUserDefinedRefDataFlightController;